<template>
  <Modal
    v-model="_value"
    width="500"
    title="查看/修改业务笔记"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <Form ref="businessNoteForm" :model="businessNoteInfo" :rules="rules" style="display: inline;">
      <FormItem>
        <label>最近修改时间:</label>
        <label>{{formatDate(businessNoteInfo.updateDatetime)}}</label>
      </FormItem>
      <FormItem prop="businessState" v-if="showBusinessState">
        <label style="display: inline-block; width: 60px;">业务状态</label>
        <Select style="display: inline-block; width: 200px;"
                v-model="businessNoteInfo.businessState">
          <Option v-for="item in businessState" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="colorLabel" >
        <label style="display: inline-block; width: 60px;">颜色标签</label>
        <Select style="display: inline-block; width: 200px;"
                v-model="businessNoteInfo.colorLabel">
          <Option v-for="item in colorLabelOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="title">
        <label style="display: inline-block; width: 60px;">标题</label>
        <Input style="display: inline-block; width: 400px;"
               v-model="businessNoteInfo.title" placeholder="请输入标题">
        </Input>
      </FormItem>
      <FormItem prop="pubType">
        <label style="display: inline-block; width: 60px;">公开类型</label>
        <Select style="display: inline-block; width: 200px;"
                v-model="businessNoteInfo.pubType">
          <Option v-for="item in pubTypeOptions" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem prop="content">
        <label style="display: inline-block; width: 60px;">笔记内容</label>
        <Input style="display: inline-block; width: 400px;" type="textarea"
               v-model="businessNoteInfo.content" placeholder="请输入笔记内容">
        </Input>
      </FormItem>
    </Form>
    <Row style="text-align: right;">
      <Button type="primary" @click="modifyChange">修改</Button>
    </Row>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'BusinessNoteDetailModal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null,
    showBusinessState: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isAdd: true,
      modify: false,
      pubTypeOptions: [
        { label: '不公开', value: 1 },
        { label: '公开名称', value: 2 },
        { label: '公开内容', value: 3 }
      ],
      colorLabelOptions: [
        // {label:'无', value: null},
        { label: '红色', value: 'ed4014' },
        { label: '橙色', value: 'ff9900' },
        { label: '黄色', value: 'ffff00' },
        { label: '绿色', value: '19be6b' },
        { label: '蓝色', value: '2db7f5' },
        { label: '紫色', value: '8a2be2' }
      ],
      businessState: [
        { label: '待开发', value: 1 },
        // {label: '在网', value: 2},
        { label: '继续沟通', value: 3 },
        { label: '沟通未果', value: 4 },
        // {label: '待安装', value: 5},
        // {label: '待拆机', value: 6},
        // {label: '待收款', value: 7},
        // {label: '服务到期', value: 8},
        // {label: '离网', value: 9},
        // {label: '准备到期', value: 10}
        { label: '同意入网', value: 11 }
      ],
      businessNoteInfo: {
        id: null,
        pubType: 1,
        businessState: null,
        colorLabel: null,
        title: null,
        content: null,
        updateDatetime: null
      }
    }
  },
  methods: {
    ...mapActions([
      'BusinessNoteServ_GetDetail',
      'BusinessNoteServ_ModifyObj',
      'BusinessNoteServ_AddObj'
    ]),
    formatDate (val) {
      if (val) {
        let d = new Date(val)
        return d.Format('yyyy年MM月dd日 hh:mm:ss')
      } else {
        return '无'
      }
    },
    modifyChange () {
      this.$Modal.confirm({
        title: '确认修改业务笔记',
        content: '<p>确认修改业务笔记</p>',
        onOk: () => {
          if (this.isAdd) {
            this.businessNoteInfo.id = null
            store.dispatch('BusinessNoteServ_AddObj', {
              params: this.businessNoteInfo
            }).then(() => {
              this.$Message.success('修改成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          } else {
            store.dispatch('BusinessNoteServ_ModifyObj', {
              params: this.businessNoteInfo
            }).then(() => {
              this.$Message.success('修改成功')
              this.$emit('on-success')
            }).catch(err => {
              this.$Message.error(err)
              this.$emit('on-fail')
            })
          }
        },
        onCancel: () => {
          if (this.businessNoteInfo.id) {
            store.dispatch('BusinessNoteServ_GetDetail', {
              params: { id: this.businessNoteInfo.id }
            }).then(() => {
              this.businessNoteInfo = store.getters.get_BusinessNote_GetDetailResult
            }).catch(err => {
              // this.$Message.error(err)
            })
          } else {
            this.businessNoteInfo.businessState = null
            this.businessNoteInfo.content = null
            this.businessNoteInfo.updateDatetime = null
          }
        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.modify = false
        this.businessNoteInfo.businessState = null
        this.businessNoteInfo.pubType = 1
        this.businessNoteInfo.content = null
        this.businessNoteInfo.updateDatetime = null
        this.businessNoteInfo.title = null
        this.businessNoteInfo.colorLabel = null
        let businessNoteInfo = this._initValue
        if (businessNoteInfo) {
          this.businessNoteInfo = businessNoteInfo
          if (this.businessNoteInfo.id) {
            store.dispatch('BusinessNoteServ_GetDetail', {
              params: { id: businessNoteInfo.id }
            }).then(() => {
              this.businessNoteInfo = store.getters.get_BusinessNote_GetDetailResult
              this.isAdd = false
            }).catch(err => {
              this.isAdd = true
              // this.$Message.error(err)
            })
          } else {
            this.isAdd = true
          }
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _showBusinessState: {
      get () {
        return this.showBusinessState
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    rules () {
      return {
        total: this.totalRules,
        payType: this.payTypeRules,
        occurrenceDatetime: this.occurrenceDatetimeRules
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.modify = false
      this.businessNoteInfo.businessState = null
      this.businessNoteInfo.pubType = 1
      this.businessNoteInfo.content = null
      this.businessNoteInfo.updateDatetime = null
      this.businessNoteInfo.title = null
      this.businessNoteInfo.colorLabel = null
    })
  }
}
</script>
